export default {
    edit: 'Düzenle',
    location: 'Konum + Şartlar ve Koşullar',
    filter: 'Filtre',
};
